import { platformEnv } from '@/platform/config/env'
import { readReferralCode } from '@/platform/referrals/model/referralCookie'
import { cookieDomain, safeReturnPath } from './sessionPolicy'

export function ssoLoginUrl(returnTo = window.location.href) {
  const origin = window.location.origin
  const path = safeReturnPath(returnTo, origin)
  const shared = cookieDomain(window.location.hostname)
  const sameDomain = shared !== undefined && shared === cookieDomain(new URL(platformEnv.ssoFrontendUrl).hostname)
  const callback = new URL('/auth/callback', origin)
  callback.searchParams.set('returnTo', path)
  const login = new URL('/auth/login', platformEnv.ssoFrontendUrl)
  login.searchParams.set('redirect_url', sameDomain ? `${origin}${path}` : callback.href)
  const referral = new URLSearchParams(window.location.search).get('ref')?.trim() || readReferralCode()
  if (referral) login.searchParams.set('ref', referral)
  return login.href
}

export function redirectToSso(returnTo?: string) {
  window.location.assign(ssoLoginUrl(returnTo))
}
